import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import withReduxState from "../../../hoc/wReduxState";
import FormInputs from "../../../components/UI/FormInputs";
import {
  getLookupByKey,
  isObject,
  isSet,
} from "../../../utils/commonUtils";
import Buttons from "../../../components/UI/Buttons";
import { VISIT_CATEGORY } from "../../../utils/constant";
import CompanyService from "../../../services/CompanyService";
import { FieldValidationFocus } from "../../../utils/cssUtils";
import VisitsService from "../../../services/VisitsService";
import WithRoutify from "../../../hoc/WithRoutify";
import Employeeervice from "../../../services/EmployeeService";
import DropDownService from "../../../services/DropDownService";
import ClinicService from "../../../services/ClinicService";
import AddAuthorizationTreatment from "../../../containers/EmployeeVisitContainer/AddAuthorizationTreatment";
import { PatientFormModelWithHoc } from "../../../containers/EmployeeVisitContainer/PatientFormModel";
import AddIncidentModal from "../../../containers/EmployeeVisitContainer/AddIncidentModal";
import Alert from "../../../components/UI/ConfirmBox/Alert";
import moment from "moment"; 

const NewPatientCalendar = (props) => {
  const employee_id = props.profile.employee_id;
  const { Toast, Loader } = props;
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  //  State Hooks 
  const [formData, setFormData] = useState({});
  const [activeAppointmentTab, setActiveAppointmentTab] = useState("Schedule Appointment");
  const [selectedTimeSlot, setSelectedTimeSlot] = useState(null);
  const [validation, setValidation] = useState({});
  const [visitCategoryOptions, setvisitCategoryOptions] = useState([]);
  const [visitReasonOptions, setVisitReasonOptions] = useState([]);
  const [companyServiceOption, setCompanyServiceOption] = useState([{ label: "-Select Service-", value: "" }]);
  const [physicalServices, setPhysicalServices] = useState([]);
  const [clinicLocationOptions, setClinicLocationOptions] = useState([{ label: "-Select Clinic Location-", value: "" }]);
  const [employeeInitialClinicId, setEmployeeInitialClinicId] = useState("");
  const [showClinicChangeConfirm, setShowClinicChangeConfirm] = useState(false);
  const [pendingClinicChange, setPendingClinicChange] = useState(null);

  // 2. NEW STATE FOR AVAILABILITY
  const [employeeHolidays, setEmployeeHolidays] = useState([]);
  const [employeeDisabledDays, setEmployeeDisabledDays] = useState([]);
  const [employeeAvailability, setEmployeeAvailability] = useState([]);
  const [allowedRanges, setAllowedRanges] = useState([]);
  const [showAuthorizationTreatmentModal, setShowAuthorizationTreatmentModal] = useState(false);
  const [savedVisit, setSavedVisit] = useState({});
  const [showPatientFormModel, setShowPatientFormModel] = useState(false);
  const [activityList, setActivityList] = useState([]);
  const [services, setServices] = useState([]);
  const [showIncidentModal, setShowIncidentModal] = useState(false);
  const [selectedBodyPart, setSelectedBodyPart] = useState("");

  const dayNameMap = {
    MON: "Monday",
    TUE: "Tuesday",
    WED: "Wednesday",
    THU: "Thursday",
    FRI: "Friday",
    SAT: "Saturday",
    SUN: "Sunday",
  };

  // Function to fetch employees for companies assigned to the user (data sharing)
  const fetchEmployeeOptions = async (searchTerm, callback) => {
    let optionsArr = [];
    try {
      const response = await DropDownService.getEmployeeListByUserCompanies(null);
      if (response && Array.isArray(response)) {
        // Filter by search term if provided
        const filtered = searchTerm 
          ? response.filter(emp => {
              const name = emp.name || `${emp.first_name || ''} ${emp.last_name || ''}`.trim();
              const email = emp.email || '';
              const searchLower = searchTerm.toLowerCase();
              return name.toLowerCase().includes(searchLower) || 
                     email.toLowerCase().includes(searchLower);
            })
          : response;
        
        filtered.forEach((employee) => {
          const name = employee.name || `${employee.first_name || ''} ${employee.last_name || ''}`.trim();
          const employeeId = employee.employee_id || employee.id || employee.user_id;
          // Only add if employeeId is valid
          if (employeeId) {
            optionsArr.push({
              label: name,
              value: employeeId,
              name: name,
            });
          }
        });
      }
    } catch (error) {
      console.error("Error fetching employees:", error);
    }
    
    callback(optionsArr);
  };

  const employeeInputFields = [
    {
      type: "SelectSearchList",
      label: "Employee",
      placeholder: "Employee",
      className: "form-control form-control-solid",
      name: "employee_id",
      col: "col-6",
      isAsync: true,
      options: [],
      loadCallBack: fetchEmployeeOptions,
      isCacheNeeded: false,
      required: true,
    },
    {
      type: "SelectList",
      label: "Clinic Location",
      placeholder: "Clinic Location",
      className: "form-control form-control-solid",
      name: "clinic_location_id",
      col: "col-6",
      options: clinicLocationOptions,
      required: true,
      readOnly: !formData.employee_id,
    },
    {
      type: "SelectList",
      label: "Visit Category",
      placeholder: "",
      className: "form-control form-control-solid",
      name: "visit_category",
      col: "col-6",
      options: visitCategoryOptions,
      required: true,
    },
    {
      label: "Contracted Services",
      type: "SelectList",
      className: "form-control form-control-solid",
      col: "col-6",
      name: "standard_services",
      required: true,
      options: companyServiceOption,
    },{
      label: "Additional Services (Optional)",
      type: "SelectSearchList",
      placeholder: "Additional Services",
      className: "form-control form-control-solid",
      col: "col-6",
      name: "additional_services",
      required: false,
      isMulti: true,
      options: activityList,
    },
    {
      type: "SelectList",
      label: "Reason for Visit",
      col: "col-6",
      placeholder: "",
      className: "form-control form-control-solid",
      name: "visit_reason",
      options: visitReasonOptions,
    }
  ];

  const appointmentsTab = [
    {
      label: "Schedule Appointment",
      isActive: true,
      name: "Schedule Appointment",
    },
    {
      label: "Walk-In Appointment",
      isActive: false,
      name: "Walk-In Appointment",
    },
  ];

  const scheduleTimes = ["12:00 AM","12:30 AM","01:00 AM", "01:30 AM", "02:00 AM","02:30 AM",
                         "03:00 AM","03:30 AM", "04:00 AM","04:30 AM","05:00 AM","05:30 AM",
                         "06:00 AM","06:30 AM","07:00 AM","07:30 AM","08:00 AM","08:30 AM",
                         "09:00 AM","09:30 AM","10:00 AM","10:30 AM","11:00 AM","11:30 AM",
                         "12:00 PM","12:30 PM","01:00 PM","01:30 PM","02:00 PM","02:30 PM",
                         "03:00 PM","03:30 PM","04:00 PM","04:30 PM","05:00 PM","05:30 PM",
                         "06:00 PM","06:30 PM","07:00 PM","07:30 PM","08:00 PM","08:30 PM",
                         "09:00 PM","09:30 PM","10:00 PM","10:30 PM","11:00 PM","11:30 PM",
  ];
  const walkInTimes = [...scheduleTimes]; 

  // --- UseEffects ---
   useEffect(() => {
    // Note: employee_name and employee_id will be set when user selects from dropdown
    // We no longer auto-populate from logged-in user profile
    // Visit category options will be fetched when employee is selected
  }, [props.profile]);

  useEffect(() => {
    fetchVisitCategory();
    fetchVisitReason();
  }, []);

  useEffect(() => {
    fetchActivities();
  }, []);

  // Check for employee_id in URL params and pre-select employee
  useEffect(() => {
    const employeeIdFromUrl = searchParams.get('employee_id');
    if (employeeIdFromUrl && !formData.employee_id) {
      // Pre-select the employee from URL param
      handleInputChange('employee_id', employeeIdFromUrl);
      // Clear the URL param to avoid re-selecting on refresh
      searchParams.delete('employee_id');
      setSearchParams(searchParams, { replace: true });
    }
  }, []); // Run only on mount

  const fetchActivities = async () => {
    try {
      const response = await DropDownService.getActivityDropdownList(null);
      const opt = [{ label: "ALL", value: "ALL" }];
      if (response && Array.isArray(response)) {
        response.forEach((itm) => {
          opt.push({
            label: itm.activity_name,
            value: itm.actitivity_id || itm.activity_id,
            activity_type: itm.activity_type,
          });
        });
      }
      setActivityList(opt);
    } catch (err) {
      console.error("Error fetching activity list:", err);
    }
  };

  // Helper: apply clinic availability filtering for a given date
  const applyAvailabilityForDate = (dateStr) => {
    if (!dateStr) return;
    const dayName = new Date(dateStr).toLocaleDateString("en-US", {
      weekday: "long",
    });
    const matchingDay = employeeAvailability.find(
      (dayObj) => dayNameMap[dayObj.day] === dayName
    );
    setSelectedTimeSlot(null);
    setFormData((prev) => ({ ...prev, visit_time: "" }));
    if (matchingDay && matchingDay.slots && matchingDay.slots.length > 0) {
      const formattedSlots = matchingDay.slots.map((slot) => ({
        from: slot.from_time,
        to: slot.to_time,
      }));
      setAllowedRanges(formattedSlots);
    } else {
      setAllowedRanges([]);
    }
  };

  // Update visit_date when selectedVisitDate prop changes (from CalendarWidget)
  useEffect(() => {
    if (props.selectedVisitDate) {
      setFormData((prev) => ({
        ...prev,
        visit_date: props.selectedVisitDate,
      }));
      applyAvailabilityForDate(props.selectedVisitDate);
    } else {
      const today = new Date();
      const todayStr = moment(today).format('MM/DD/YYYY');
      setFormData((prev) => ({
        ...prev,
        visit_date: todayStr,
      }));
    }
  }, [props.selectedVisitDate]);

  // Re-apply clinic availability when employeeAvailability changes (e.g. after selecting employee).
  // Fixes default "today" not blocking time until user changes date.
  useEffect(() => {
    const visitDate = props.selectedVisitDate || moment(new Date()).format('MM/DD/YYYY');
    if (!visitDate || employeeAvailability.length === 0) return;
    const dayName = new Date(visitDate).toLocaleDateString("en-US", { weekday: "long" });
    const matchingDay = employeeAvailability.find(
      (dayObj) => dayNameMap[dayObj.day] === dayName
    );
    setSelectedTimeSlot(null);
    setFormData((prev) => ({ ...prev, visit_time: "" }));
    if (matchingDay?.slots?.length > 0) {
      setAllowedRanges(
        matchingDay.slots.map((slot) => ({ from: slot.from_time, to: slot.to_time }))
      );
    } else {
      setAllowedRanges([]);
    }
  }, [employeeAvailability, props.selectedVisitDate]);

  // fetch clinic availability by clinic_id (used on employee select + clinic change confirm)
  const fetchClinicAvailabilityByClinic = async (clinic_id) => {
    if (!clinic_id) return;
    try {
      const res = await VisitsService.clinicAvailability(clinic_id);
      const data = res?.data || res;
      const holidays = data?.holidays || [];
      const availability = data?.availability || [];
      const activeHolidayDates = (holidays || [])
        .filter((h) => h.is_active === 1)
        .map((h) => h.date);
      setEmployeeHolidays(activeHolidayDates);
      setEmployeeAvailability(availability);
      const disabledDays = (availability || [])
        .filter((dayObj) => dayObj.is_repeatable === 0)
        .map((dayObj) => dayNameMap[dayObj.day] || dayObj.day);
      setEmployeeDisabledDays(disabledDays);
    } catch (err) {
      console.error("Error fetching clinic availability:", err);
    }
  };

  const handleTabChange = (tabName) => {
    setActiveAppointmentTab(tabName);
    setSelectedTimeSlot(null);
    setFormData((prev) => ({ ...prev, visit_time: "" }));
  };

  const handleTimeSelect = (time) => {
    setSelectedTimeSlot(time);
    // Also update form data so validation passes
    handleInputChange("visit_time", time);
  };

  const currentSlots =
    activeAppointmentTab === "Schedule Appointment"
      ? scheduleTimes
      : walkInTimes;

  const fetchVisitCategory = async () => {
    const key = await getLookupByKey(VISIT_CATEGORY);
    setvisitCategoryOptions(key);
  };

  const fetchVisitReason = async () => {
    const options = await getLookupByKey("Visit Reason");
    setVisitReasonOptions(options);
  };

  // Fetch employee details + clinic list, populate clinic and pre-select employee's clinic, then return clinic_id for availability
  const fetchEmployeeDetailsAndCategory = async (employee_id) => {
    try {
      // Fetch clinic list and employee details in parallel for speed
      const [allClinics, employeeDetails] = await Promise.all([
        DropDownService.getClinicList(null),
        Employeeervice.getEmployee(employee_id),
      ]);

      if (!employeeDetails || !employeeDetails.company_id) return "";

      const company_id = employeeDetails.company_id;
      const employee_clinic_id = employeeDetails.clinic_id;

      // Populate clinic dropdown immediately from data-sharing list
      let clinicOptions = [{ label: "-Select Clinic Location-", value: "" }];
      if (allClinics && Array.isArray(allClinics)) {
        allClinics.forEach((clinic) => {
          clinicOptions.push({
            label: clinic.name || clinic.clinic_name || clinic.clinic_location_name || "Clinic",
            value: clinic.clinic_id || clinic.clinic_uuid || clinic.id,
          });
        });
      }
      setClinicLocationOptions(clinicOptions);

      // Pre-select employee's clinic right away
      const clinicId = employee_clinic_id && clinicOptions.some((opt) => opt.value === employee_clinic_id)
        ? employee_clinic_id
        : "";

      setEmployeeInitialClinicId(clinicId || "");
      setFormData((prev) => ({
        ...prev,
        company_id,
        clinic_location_id: clinicId,
      }));

      // Then fetch visit category (non-blocking)
      fetchVisitCategoryOptions(company_id).catch((e) => console.error("Error fetching visit category", e));
      return clinicId || "";
    } catch (error) {
      console.error("Error fetching employee details:", error);
      setClinicLocationOptions([{ label: "-Select Clinic Location-", value: "" }]);
      setEmployeeInitialClinicId("");
      return "";
    }
  };

  const fetchVisitCategoryOptions = async (company_id) => {
    if (!company_id) return false;
    try {
      let companyPhysical = await CompanyService.getCompaniesPhysical(
        company_id
      );
      const companyPhysicalData = companyPhysical?.data?.data || [];
      setPhysicalServices(companyPhysicalData);
    } catch (error) {
      console.error("Error fetching physical services", error);
    }
  };

  const handleClinicChangeConfirm = async () => {
    const clinicId = pendingClinicChange;
    if (clinicId != null) {
      setFormData((prev) => ({ ...prev, clinic_location_id: clinicId }));
    }
    setShowClinicChangeConfirm(false);
    setPendingClinicChange(null);

    if (clinicId && Loader) {
      Loader(true);
      try {
        await fetchClinicAvailabilityByClinic(clinicId);
      } finally {
        Loader(false);
      }
    }
  };

  const handleClinicChangeCancel = () => {
    setShowClinicChangeConfirm(false);
    setPendingClinicChange(null);
  };

  // Handlers
  const handleInputChange = (name, value) => {
    setValidation((prev) => ({ ...prev, [name]: "" }));

    // Clinic change: show Alert if switching away from employee's initial clinic
    if (name === "clinic_location_id") {
      const newClinicId = (typeof value === "object" ? (value?.value ?? value?.id ?? "") : value) ?? "";
      const newId = String(newClinicId).trim();
      if (
        employeeInitialClinicId &&
        newId &&
        newId !== employeeInitialClinicId
      ) {
        setPendingClinicChange(newId);
        setShowClinicChangeConfirm(true);
        return;
      }
    }

    // Handle Additional Services with "ALL" option logic (similar to AddVisits)
    if (name === "additional_services") {
      // SelectSearchList with isMulti returns comma-separated string
      const selectedValues = value ? (typeof value === 'string' ? value.split(',').filter(v => v.trim()) : [value]) : [];
      
      // Check if "ALL" is in the selected values
      const hasAll = selectedValues.includes('ALL');
      const nonAllOptions = activityList.filter(item => item.value !== 'ALL');
      const allSelected = nonAllOptions.length > 0 && selectedValues.length === nonAllOptions.length;
      
      let updatedServices = [];
      if (hasAll) {
        // If "ALL" is selected, select only "ALL"
        updatedServices = ['ALL'];
      } else if (allSelected && !hasAll) {
        // If all items are selected (except ALL), automatically select "ALL"
        updatedServices = ['ALL'];
      } else {
        // Normal selection - filter out "ALL" if it exists
        updatedServices = selectedValues.filter(val => val !== 'ALL' && val.trim() !== '');
      }

      setServices(updatedServices);
      setFormData((prev) => ({
        ...prev,
        additional_services: updatedServices.join(','),
      }));
      return; // Early return to prevent default form data update
    }

    // Update Form Data
    setFormData((prevData) => {
      let updatedFormData = {
        ...prevData,
        [name]: value,
      };
      
      // Handle employee selection
      if (name === "employee_id") {
        // Extract employee_id from value (handle both string and object)
        let validEmployeeId = value;
        if (typeof value === 'object' && value !== null) {
          validEmployeeId = value.value || value.employee_id || value.id;
        }
        
        // Convert to string and check for invalid values
        validEmployeeId = String(validEmployeeId || '').trim();
        if (validEmployeeId === 'null' || validEmployeeId === 'undefined' || validEmployeeId === '') {
          validEmployeeId = null;
        }
        
        // Update formData with the valid employee_id
        updatedFormData[name] = validEmployeeId;
        
        // Fetch employee details + clinic list → pre-select employee's clinic → load that clinic's availability
        if (validEmployeeId) {
          if (Loader) Loader(true);
          fetchEmployeeDetailsAndCategory(validEmployeeId)
            .then((clinicId) => (clinicId ? fetchClinicAvailabilityByClinic(clinicId) : Promise.resolve()))
            .finally(() => { if (Loader) Loader(false); });
        } else {
          // Reset when employee is cleared
          updatedFormData.company_id = "";
          updatedFormData.clinic_location_id = "";
          setClinicLocationOptions([{ label: "-Select Clinic Location-", value: "" }]);
          setEmployeeInitialClinicId("");
          setEmployeeHolidays([]);
          setEmployeeAvailability([]);
          setEmployeeDisabledDays([]);
          setAllowedRanges([]);
        }
      }
      
      if (name === "visit_category") {
        updatedFormData.standard_services = "";
      }
      
      return updatedFormData;
    });

    // DATE CHANGE LOGIC
    if (name === "visit_date") {
      const selectedDate = value;
      const dayName = new Date(selectedDate).toLocaleDateString("en-US", {
        weekday: "long",
      });
     // Find availability for that day
      const matchingDay = employeeAvailability.find(
        (dayObj) => dayNameMap[dayObj.day] === dayName
      );
     // Reset selected time slot when date changes
      setSelectedTimeSlot(null);
      setFormData((prev) => ({ ...prev, visit_time: "" }));

      if (matchingDay && matchingDay.slots && matchingDay.slots.length > 0) {
        const formattedSlots = matchingDay.slots.map((slot) => ({
          from: slot.from_time,
          to: slot.to_time,
        }));
        setAllowedRanges(formattedSlots);
      } else {
        setAllowedRanges([]);
      }
    }

    // Logic to filter Contracted Services based on Category
    if (name === "visit_category") {
      let opt = [{ label: "-Select Service-", value: "" }];
      if (value === "Employer Services - Physicals") {
        physicalServices.forEach((itm) => {
          opt.push({
            label: itm.physical_name,
            value: itm.company_physical_id,
          });
        });
      }
      if (value === 'Employer Services - DOT Physicals') {
        let dotPhysicalsEnabled = physicalServices.filter(item => item.dot_physicals == 1);
        dotPhysicalsEnabled.forEach((itm) => {
          opt.push({ label: itm.physical_name, value: itm.company_physical_id });
        });
      }
      if (value === "Employer Services - Drug Screens") {
        let drugScreeEnabled = physicalServices.filter(
          (item) => item.drug_screen == 1
        );
        drugScreeEnabled.forEach((itm) => {
          opt.push({
            label: itm.physical_name,
            value: itm.company_physical_id,
          });
        });
      }
      setCompanyServiceOption(opt);
    }
  };

  // HELPER TO CHECK IF A TIME IS VALID
  const isTimeInAllowedRange = (timeStr) => {
    if (!formData.visit_date || allowedRanges.length === 0) return false;
    const timeMoment = moment(timeStr, "hh:mm A");
    return allowedRanges.some((slot) => {
      const fromMoment = moment(slot.from, "hh:mm A");
      const toMoment = moment(slot.to, "hh:mm A");
      return timeMoment.isBetween(fromMoment, toMoment, null, "[]");
    });
  };

  const authorizationToogleHandler = (val = false) => {
    setShowAuthorizationTreatmentModal(val);
    if (!val) {
      // After closing authorization modal, open patient form modal (send notes)
      setTimeout(() => {
        patientFormToogleHandler();
      }, 250);
    }
  };

  const patientFormToogleHandler = (closeModal = false) => {
    if (closeModal) {
      setShowPatientFormModel(false);
      // Define visit categories that require incident modal
      const workCompCategories = ['Work Comp - New Injury', 'Work Comp - Follow Up'];
      const urgentCareCategories = ['Urgent Care - Injury', 'Urgent Care - Illness', 'Urgent Care - Follow Up', 'Urgent Care - Cash Patient', 'Urgent Care - Telehealth'];
      const privateCategories = ['Private - Mental Health Exam', 'Private - Primary Care - Initial', 'Private - Primary Care - Follow Up'];
      const incidentRequiredCategories = [...workCompCategories, ...urgentCareCategories, ...privateCategories];
      
      if (incidentRequiredCategories.includes(savedVisit.visit_category)) {
        setShowIncidentModal(true);
      } else {
        navigate("/visits");
      }
    } else {
      setShowPatientFormModel(!showPatientFormModel);
    }
  };

  const incidentModalHandler = () => {
    setShowIncidentModal(false);
    navigate("/visits");
  };
  
  // Get visit category from savedVisit for AddIncidentModal
  const visitCategory = savedVisit?.visit_category || null;

  const formSubmitHandler = async () => {
    let updateValidation = {};
    let validationErrors = {};
    let isValid = true;

    if (!formData.employee_id) {
      validationErrors["employee_id"] = "Patient/Employee is required";
      isValid = false;
    }
    if (!formData.company_id) {
      validationErrors["employee_id"] = "Please select a valid employee";
      isValid = false;
    }
    if (!formData.clinic_location_id) {
      validationErrors["clinic_location_id"] = "Clinic Location is required";
      isValid = false;
    }
    if (!formData.visit_category) {
      validationErrors["visit_category"] = "Visit Category is required";
      isValid = false;
    }
    if (!formData.visit_date) {
      validationErrors["visit_date"] = "Visit Date is required";
      isValid = false;
    }
    if (!formData.visit_time) {
       validationErrors["visit_time"]="Please select a time slot";
      isValid = false;
    }

    // Validate Contracted Service is required when Visit Category is "Employer Services - Physicals" or "Employer Services - Drug Screens"
    // Only require if there are options available (more than just the default "-Select Service-" option)
    const hasContractServiceOptions = companyServiceOption.length > 1; // More than just the default option
    if ((formData.visit_category === 'Employer Services - Physicals' || formData.visit_category === 'Employer Services - Drug Screens') && hasContractServiceOptions) {
      if (!formData.standard_services || formData.standard_services === '') {
        validationErrors['standard_services'] = `The Contracted Service field is required`;
        isValid = false;
      }
    }

    if (!isValid) {
      setValidation({ ...updateValidation, ...validationErrors });
      FieldValidationFocus(employeeInputFields, validationErrors);
      return false;
    }

    const currentClinicId = formData.clinic_location_id || "";

    // Destructure to exclude clinic_location_id and additional_services from payload
    const { clinic_location_id, additional_services, ...formDataWithoutClinic } = formData;

    let optionalServicesValue = services.join(',');
    if (optionalServicesValue === "ALL") {
      const filterAllActivityList = activityList.filter(itm => itm.value !== "ALL").map(itm => itm.value);
      optionalServicesValue = filterAllActivityList.join(',');
    }

    let payload = {
      ...formDataWithoutClinic,
      company_id: formData.company_id,
      employee_id: formData.employee_id,
      optional_services: optionalServicesValue,
    };

    if (currentClinicId) {
      payload.assigned_clinic_id = currentClinicId;
    }

    try {
      props.Loader(true);
      const data = await VisitsService.saveVisits(
        isSet(formData.organization, null),
        payload
      );
      if (data.status && data.status === "ERROR") {
        let toastMsg = "";
        if (isObject(data.data)) {
          for (let key in data.data) {
            const error = data.data[key].join(",");
            updateValidation = { ...updateValidation, [key]: error };
            if (!toastMsg) toastMsg = error;
          }
          if (toastMsg) Toast.error(toastMsg);
        }
        if (Object.keys(updateValidation).length > 0) {
          setValidation(updateValidation);
          FieldValidationFocus(employeeInputFields, updateValidation);
        }
      } else {
        // Fetch the saved visit details
        if (data.visit_id) {
          try {
            const savedVisitData = await VisitsService.getVisits(data.visit_id);
            const savedVisitDetails = savedVisitData[0];
            setSavedVisit(savedVisitDetails);
            
            // Check if user role is employer_admin
            if (props.profile?.role === 'employer_admin') {
              authorizationToogleHandler(true);
      } else {
        Toast.success("Visit Added Successfully");
            }
          } catch (error) {
            console.error("Error fetching visit details:", error);
            Toast.success("Visit Added Successfully");
          }
        } else {
          Toast.success("Visit Added Successfully");
        }
        
       setFormData((prev) => ({
          employee_id: "",     
          visit_category: "",
          standard_services: "",
          additional_services: "",
          visit_date: "",
          visit_time: "",
          visit_reason: "",
          }));
        setServices([]);
        setSelectedTimeSlot(null);
        setAllowedRanges([]);
      }
      props.Loader(false);
    } catch (e) {
      console.error(e);
      if (Loader) Loader(false);
      Toast.error("An unexpected error occurred.");
    }
  };

  return (
    <div>
      {/* Search Bar and Status Indicators (Unchanged) */}
      <div className="d-flex">
        <div className="p-2 w-100" style={{ maxWidth: "300px" }}>
          <input
            className="form-control form-control-solid"
            placeholder="Search"
          />
        </div>
      </div>
      {/* Status Indicators */}

      <div className="row g-3 mb-3">
        {/* Scheduled */}

        <div className="col-12 col-sm-6 col-xl-3">
          <div className="d-flex sh_statusIndicatorbox blue-orichid px-3 py-2">
            <div className="d-flex align-items-center ">
              <span className="sh_statusIndicator bg-light">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19 4H5C3.895 4 3 4.895 3 6V19C3 20.105 3.895 21 5 21H19C20.105 21 21 20.105 21 19V6C21 4.895 20.105 4 19 4Z"
                    stroke="#1D2433"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />

                  <path
                    d="M16 3V6"
                    stroke="#1D2433"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />

                  <path
                    d="M12 3V6"
                    stroke="#1D2433"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />

                  <path
                    d="M8 3V6"
                    stroke="#1D2433"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />

                  <path
                    d="M12 16H17"
                    stroke="#1D2433"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />

                  <path
                    d="M8.63389 15.1161C9.12204 15.6043 9.12204 16.3957 8.63389 16.8839C8.14573 17.372 7.35428 17.372 6.86612 16.8839C6.37796 16.3957 6.37796 15.6043 6.86612 15.1161C7.35427 14.628 8.14573 14.628 8.63389 15.1161"
                    stroke="#1D2433"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />

                  <path
                    d="M12 11H17"
                    stroke="#323232"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />

                  <path
                    d="M8.63389 10.1161C9.12204 10.6043 9.12204 11.3957 8.63389 11.8839C8.14573 12.372 7.35428 12.372 6.86612 11.8839C6.37796 11.3957 6.37796 10.6043 6.86612 10.1161C7.35427 9.62796 8.14573 9.62796 8.63389 10.1161"
                    stroke="#323232"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
            </div>

            <div className="d-flex flex-column">
              <p className="p1-light text-dark mb-0">Scheduled</p>

              <h3 className="h3-strong mb-0">40</h3>
            </div>
          </div>
        </div>

        {/* Open Visits */}

        <div className="col-12 col-sm-6 col-xl-3">
          <div className="d-flex sh_statusIndicatorbox pale-purple px-3 py-2">
            <div className="d-flex align-items-center ">
              <span className="sh_statusIndicator bg-light">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.5 3V6"
                    stroke="#1D2433"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />

                  <path
                    d="M16.5 3V6"
                    stroke="#1D2433"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />

                  <path
                    d="M10 21H6C4.34315 21 3 19.6569 3 18V7.5C3 5.84315 4.34315 4.5 6 4.5H18C19.6569 4.5 21 5.84315 21 7.5V10"
                    stroke="#1D2433"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />

                  <path
                    d="M17.8685 18.7361L16.6309 17.4989L17.8685 16.2617"
                    stroke="#1D2433"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />

                  <circle
                    cx="17.5"
                    cy="17.5"
                    r="4.5"
                    stroke="#1D1917"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
            </div>

            <div className="d-flex flex-column">
              <p className="p1-light text-dark mb-0">Open Visits</p>

              <h3 className="h3-strong mb-0">32</h3>
            </div>
          </div>
        </div>

        {/* Completed Visits */}

        <div className="col-12 col-sm-6 col-xl-3">
          <div className="d-flex sh_statusIndicatorbox linear_gradient px-3 py-2">
            <div className="d-flex align-items-center ">
              <span className="sh_statusIndicator bg-light">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.5 3V6"
                    stroke="#1D2433"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />

                  <path
                    d="M16.5 3V6"
                    stroke="#1D2433"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />

                  <path
                    d="M12 21H6C4.34315 21 3 19.6569 3 18V7.5C3 5.84315 4.34315 4.5 6 4.5H18C19.6569 4.5 21 5.84315 21 7.5V12"
                    stroke="#1D2433"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />

                  <circle
                    cx="18"
                    cy="18"
                    r="4"
                    stroke="#323232"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />

                  <path
                    d="M19.3443 17.208L17.6643 18.887L16.6543 17.88"
                    stroke="#1D2433"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />

                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 11.6905V13.4165C12 13.9688 11.5523 14.4165 11 14.4165H8C7.44772 14.4165 7 13.9688 7 13.4165V11.6425C7 11.2628 7.17262 10.9036 7.46915 10.6664L8.68915 9.6904C9.14567 9.3252 9.79433 9.3252 10.2508 9.6904L11.5308 10.7144C11.8274 10.9516 12 11.3108 12 11.6905V11.6905Z"
                    stroke="#1D2433"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
            </div>

            <div className="d-flex flex-column">
              <p className="p1-light text-dark mb-0">Completed Visits </p>
              <h3 className="h3-strong mb-0">8</h3>
            </div>
          </div>
        </div>

        {/* Notes */}

        <div className="col-12 col-sm-6 col-xl-3">
          <div className="d-flex sh_statusIndicatorbox olivegreen px-3 py-2">
            <div className="d-flex align-items-center ">
              <span className="sh_statusIndicator bg-light">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11 3H6C4.34315 3 3 4.34315 3 6V9"
                    stroke="#1D2433"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />

                  <path
                    d="M17 21H18C19.6569 21 21 19.6569 21 18V13"
                    stroke="#1D2433"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />

                  <ellipse
                    cx="17"
                    cy="7"
                    rx="4"
                    ry="4"
                    stroke="#323232"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />

                  <path
                    d="M18.25 6.5L16.6883 8L15.75 7.1"
                    stroke="#1D2433"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />

                  <ellipse
                    cx="8"
                    cy="13.5"
                    rx="2.5"
                    ry="2.5"
                    stroke="#323232"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />

                  <path
                    d="M13 21C13 19.6193 11.8807 18.5 10.5 18.5H5.5C4.11929 18.5 3 19.6193 3 21"
                    stroke="#1D2433"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
            </div>

            <div className="d-flex flex-column">
              <p className="p1-light text-dark mb-0">Notes / Communication</p>

              <h3 className="h3-strong mb-0">4</h3>
            </div>
          </div>
        </div>
      </div>

      <div className="sh_schedule_header p-2 rounded-1 mt-4">
        <p className="h5-strong font-bold mb-0 text-dark">Schedule</p>
      </div>

      {/* Top Input Fields */}
      <div className="row g-3 mb-3">
        {employeeInputFields.map((field, index) => (
          <div className="col-12 col-sm-6 col-xl-3" key={index}>
            <label
              className="f-400 text-truncate text-dark mb-0"
              style={{ fontSize: "15px" }}
            >
              {field.label}
            </label>
            <FormInputs
              type={field.type}
              name={field.name}
              className={field.className}
              placeholder={field.placeholder}
              options={field.options || []}
              value={field.name === "additional_services" 
                ? services.join(',') 
                : (formData[field.name] || "")}
              changeHandler={(val) => handleInputChange(field.name, val)}
              isMulti={field.isMulti}
              disabled={field.disabled}
              isAsync={field.isAsync}
              loadCallBack={field.loadCallBack}
              reload={field.reload}
              isCacheNeeded={field.isCacheNeeded}
              readOnly={field.readOnly}
              required={field.required}
            />
            {isSet(validation[field.name], "") !== "" ? (
              <span className="text-danger m-1 small">
                {isSet(validation[field.name], "")}
              </span>
            ) : (
              ""
            )}
          </div>
        ))}
      </div>

      {/* Tabs */}
      <div className="tabs_wrapForTable mb-3">
        <div className="nav sh_subnav border-0 d-flex gap-2">
          {appointmentsTab.map((tab, tabIndex) => {
            const isTabActive = activeAppointmentTab === tab.name;
            return (
              <label
                key={tabIndex}
                className={`flex-sm-fill text-sm-center nav-link ${
                  isTabActive ? "active" : ""
                }`}
                style={{ cursor: "pointer" }}
                onClick={() => handleTabChange(tab.name)}
              >
                <FormInputs
                  type="Radio"
                  name="scheduleType"
                  value={tab.name}
                  checked={isTabActive}
                  changeHandler={() => handleTabChange(tab.name)}
                  style={{ display: "none" }}
                />
                <span className="name h4-light text-dark">{tab.label}</span>
              </label>
            );
          })}
        </div>
      </div>

      {/*TIME SLOT BUTTONS WITH LOGIC */}
      <div className="row g-3">
        {currentSlots.map((time, index) => {
          const isAllowed = isTimeInAllowedRange(time);
          // if (!isAllowed) return null;
          return (
            <div className="col-6 col-md-4 col-xl-3" key={index}>
              <button
                className={`btn-time-slot ${
                  selectedTimeSlot === time ? "selected" : ""
                }`}
                onClick={() => handleTimeSelect(time)}
                disabled={!isAllowed}
                style={{
                  opacity: isAllowed ? 1 : 0.5,
                  cursor: isAllowed ? "pointer" : "not-allowed",
                  backgroundColor: isAllowed ? "" : "#e9ecef",
                }}
              >
                {time}
              </button>
            </div>
          );
        })}
        {/* Helper message if date not selected */}
        {!formData.visit_date && (
          <div className="col-12 text-center text-muted mt-2">
            <small>
              Please select a Visit Date to view available time slots.
            </small>
          </div>
        )}
        {/* Helper message if date selected but no slots */}
        {formData.visit_date && allowedRanges.length === 0 && (
          <div className="col-12 text-center text-danger mt-2">
            <small>No available slots for the selected date.</small>
          </div>
        )}
        {/* Validation message when no time slot selected */}
        {validation.visit_time && (
          <div className="col-12 text-center text-danger mt-2">
            <small>{validation.visit_time}</small>
          </div>
        )}
      </div>

      <br />

      <div className="d-flex justify-content-end m-3">
        <Buttons
          className="btn btn-primary"
          label={"Schedule & Next"}
          clickHandler={() => formSubmitHandler()}
        />
      </div>

      {/* Authorization Treatment Modal for employer_admin */}
      {showAuthorizationTreatmentModal && (
        <AddAuthorizationTreatment
          isOpen={showAuthorizationTreatmentModal}
          authorizationToogleHandler={(val) => authorizationToogleHandler(val)}
          visitId={savedVisit.visit_id}
          savedVisit={savedVisit}
          employeeDetails={savedVisit.employee}
          profile={props.profile}
        />
      )}

      {/* Patient Form Model (Send Notes) - opens after authorization form */}
      {showPatientFormModel && savedVisit.visit_id && (
        <PatientFormModelWithHoc
          isOpen={showPatientFormModel}
          visitId={savedVisit.visit_id}
          visitData={savedVisit}
          modalToogleHandler={patientFormToogleHandler}
          visitCategory={savedVisit.visit_category}
          services={services}
          contractService={savedVisit.standard_service?.physical_name || savedVisit.standard_services}
          activityList={activityList}
          physicalServices={physicalServices}
        />
      )}

      {/* Incident Modal - opens after patient form for Work Comp visits */}
      {showIncidentModal && savedVisit.visit_id && (
        <AddIncidentModal
          incidentToogleHandler={incidentModalHandler}
          isOpen={showIncidentModal}
          visitId={savedVisit.visit_id}
          employeeDetails={savedVisit.employee}
          isEdit={true}
          isFromIncidentList={false}
          visitCategory={visitCategory}
          selectedBodyPart={selectedBodyPart}
          setSelectedBodyPart={setSelectedBodyPart}
        />
      )}

      {/* Clinic location change confirmation */}
      {showClinicChangeConfirm && (
        <Alert
          type="warning"
          custonTitle="Clinic Location Change"
          contentTitle="This Employee Was Initially Seen at a Different Clinic Location. Please Verify That the Location Change Is Authorized Before Proceeding."
          yesButtonName="OK"
          noButtonName="Cancel"
          confirmButtonClassName="btn btn-primary"
          cancelButtonClassName="btn btn-secondary"
          onClose={handleClinicChangeCancel}
          onDelete={handleClinicChangeConfirm}
        />
      )}
    </div>
  );
};

export default withReduxState(WithRoutify(NewPatientCalendar));
